import React from "react";
import RegistrationCard from "../RegistrationCard";
import RangeRentalForm from "./RangeRentalForm";

const RangeRentalPage = ({ onSubmit, currentRegistration }) => {
  const {
    rental = false,
    ranges = { pistol: false, rifle: false }
  } = currentRegistration;

  return (
    <RegistrationCard
      title="Range and Rental"
      subtitle="Select which ranges you would like to use, and if you need a rental."
    >
      <RangeRentalForm onSubmit={onSubmit} initialValues={{ rental, ranges }} />
    </RegistrationCard>
  );
};

RangeRentalPage.propTypes = {};
RangeRentalPage.defaultProps = {};

export default RangeRentalPage;



// WEBPACK FOOTER //
// ./src/registration/components/RangeRental/RangeRentalPage.jsx